import Vue from 'vue'

import App from './App.vue'
import './registerServiceWorker'
import { vuetify } from './plugins/vuetify'
import { router } from './router'

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  data: () => ({ user: null, isLoggedIn: false }),
  render: h => h(App),
}).$mount('#app')
